import { render } from "./MessagesWithSidebar.vue?vue&type=template&id=cc5f8d56&ts=true"
import script from "./MessagesWithSidebar.vue?vue&type=script&lang=ts"
export * from "./MessagesWithSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__